module.exports = __webpack_public_path__ + "static/assets/212755cb30e347f87ebc844259c2b790.png";